import { call } from "./utils";

export const getLogsByProf = async () =>
  await call({ url: "/log/list/by/professional" });
